import React, { Fragment } from "react";
import BackgroundTheme from "../components/Intro/BackgroundTheme";
import Router from "react-router-dom";
// const BrowserHistory = require("react-router/lib/BrowserHistory").default;
function Page404({ history }) {
  return (
    <Fragment>
      <h1 className="text-3xl text-blue-700 font-bold text-center">
        Error 404 Page
      </h1>
      <h3 className="text-gray-600 text-lg mt-5 font-Cairo font-medium px-24 text-center">
        عفوا الصفحة غير متوفرة
      </h3>
      <div className="flex-1"></div>
      <button
        onClick={history.goBack}
        className="bg-blue-500 cursor-pointer px-10 py-2 text-white rounded shadow-md hover:bg-blue-600"
      >
        الرجوع
      </button>
    </Fragment>
  );
}
export default BackgroundTheme(Page404);
